var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "10px 15px 30px 15px",
        "background-color": "#fff",
        margin: "0"
      }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: {
            "margin-top": "22px",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "start"
          },
          attrs: { span: 24 }
        },
        [
          _c("span", { staticClass: "get-in-touch-email-text" }, [
            _vm._v("If you have any questions, feel free to email us")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { width: "100%" },
              attrs: { target: "_blank", href: "mailto:" + _vm.contactEmail }
            },
            [
              _c("el-button", { staticClass: "btn-primary" }, [
                _vm._v(_vm._s(_vm.contactEmail))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bc01d48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bc01d48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/emailUsSectionLight.vue
// module id = null
// module chunks = 